<template>
  <v-text-field
    :dense="dense"
    :disabled="disabled"
    :error="error"
    :error-messages="errors[0]"
    :label="label"
    :outlined="outlined"
    :placeholder="placeholder"
    :prepend-inner-icon="getPrependInnerIcon"
    :shaped="shaped"
    :success="success"
    :type="type"
    :value="value"
    :rules="rules"
    :hint="hint"
    persistent-hint
    @input="$emit('input', $event)"
  />
</template>

<script>
import { notNullOrUndefined } from '@/utility/functions';

export default {
  name: "TextField",
  props: {
    required: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: null
    },
    rules: {
      type: [Array, Object],
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    outlined: {
      type: Boolean,
      default: true
    },
    shaped: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    dense: {
      type: Boolean,
      default: true
    },
    prependInnerIcon: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getPrependInnerIcon() {
      if (notNullOrUndefined(this.prependInnerIcon)) {
        return this.prependInnerIcon;
      } else {
        return this.required ? "mdi-pencil" : "";
      }
    }
  }
};
</script>

<style scoped></style>
